import { RateLocationMapper } from "../rate-location/rate-location.mapper";

import { RateSurcharge } from "./rate-surcharge.type";
import { containerLoad } from "../../shared/container/load-types.const";
import { FclRateSurcharge } from "./rate-surcharge-fcl.model";
import { LclRateSurcharge } from "./rate-surcharge-lcl.model";
import { SurchargeTypeMapper } from "../../surcharge-type/surcharge-type.mapper";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { AirRateSurcharge } from "./rate-surcharge-air.model";

export class RateSurchargeMapper {
  public static map(data: any): RateSurcharge {
    if (!data) {
      return null;
    }

    if (!data.discriminator) {
      console.trace("no discriminator");
    }

    if (!data.discriminator || data.discriminator === containerLoad.fcl) {
      return new FclRateSurcharge(
        data.id,
        data.discriminator,
        SurchargeTypeMapper.map(data.surchargeType),
        data.rateOriginLocations
          ? data.rateOriginLocations.map(RateLocationMapper.map)
          : [],
        data.rateDestinationLocations
          ? data.rateDestinationLocations.map(RateLocationMapper.map)
          : [],
        data.marginType,
        new ContainerPrices(data.containers),
      );
    }

    if (data.discriminator === containerLoad.lcl) {
      return new LclRateSurcharge(
        data.id,
        data.discriminator,
        SurchargeTypeMapper.map(data.surchargeType),
        data.rateOriginLocations
          ? data.rateOriginLocations.map(RateLocationMapper.map)
          : [],
        data.rateDestinationLocations
          ? data.rateDestinationLocations.map(RateLocationMapper.map)
          : [],
        data.wmPrice,
        data.blPrice,
        data.minPrice,
      );
    }

    if (data.discriminator === containerLoad.air) {
      return new AirRateSurcharge(
        data.id,
        data.discriminator,
        SurchargeTypeMapper.map(data.surchargeType),
        data.rateOriginLocations
          ? data.rateOriginLocations.map(RateLocationMapper.map)
          : [],
        data.rateDestinationLocations
          ? data.rateDestinationLocations.map(RateLocationMapper.map)
          : [],
        data.weightPrice,
      );
    }
  }
}
